import { useCallback, useEffect } from 'react';
import { useThrottleFn } from 'ahooks';

/**
 * 屏幕缩放时，resize echart
 * @param chartInstance echart实例
 */
export default function useChartResize(chartInstance: any) {
  const handleResize = useCallback(() => {
    if (chartInstance.current) {
      chartInstance.current.resize();
    }
  }, []);

  const { run: handleResizeThrottled } = useThrottleFn(handleResize, {
    wait: 600,
    leading: true,
    trailing: true,
  });

  useEffect(() => {
    window.addEventListener('resize', handleResizeThrottled, false);

    return () => {
      window.removeEventListener('resize', handleResizeThrottled);
    };
  }, [handleResizeThrottled]);
}
